import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as rx from "rxjs";
import { obtenerTotalAPagar } from "./logic";


interface total {
    todas: number;
    entregadas: number;
}

interface saldoCliente {
    saldo: number;
    limite: number;
}

interface PropsRx {
    saldoSuficiente: boolean;
    creditoBloqueado: boolean;
    total: total;
    tipopago: models.TipoPagoEntregaZE;
    saldoCliente: saldoCliente;
    onChange: (x: models.TipoPagoEntregaZE) => void;
}

class PagoEntregaCompNoRX extends React.PureComponent<PropsRx> {

    saldoSuficiente = (x: PropsRx) => x.saldoSuficiente;
    total = (x: PropsRx) => x.total;
    tipopago = (x: PropsRx) => x.tipopago;
    saldoCliente = (x: PropsRx) => x.saldoCliente;
    creditoBloqueado = (x: PropsRx) => x.creditoBloqueado;


    render() {
        const saldoSuficiente = this.saldoSuficiente(this.props);
        const total = this.total(this.props);
        const tipopago = this.tipopago(this.props);
        const saldoCliente = this.saldoCliente(this.props);
        const creditoBloqueado = this.creditoBloqueado(this.props);
        const esCredito = tipopago == models.TipoPagoEntregaZE.Credito;
        return (
            <div>
                {
                    <div className={"alert alert-" + (!esCredito || (!creditoBloqueado && saldoSuficiente) ? "success" : "danger")}>

                        <label>Total a pagar:</label>
                        <h3>
                            {kea.formatCurrency(total.entregadas)}
                        </h3>

                        <label>Saldo / limite crédito:</label>
                        <h3>
                            {kea.formatCurrency(saldoCliente.saldo)}/{kea.formatCurrency(saldoCliente.limite)}
                        </h3>

                        {
                            (esCredito && creditoBloqueado) && 
                            <h3>
                                <span className="label label-danger">
                                    Linea de crédito bloqueada
                                </span>
                            </h3>
                        }

                        <kea.ButtonSelector
                            value={tipopago}
                            onChange={this.props.onChange}
                            items={[
                                {
                                    label: "Efectivo",
                                    value: models.TipoPagoEntregaZE.Efectivo
                                }, {
                                    label: "Credito",
                                    value: models.TipoPagoEntregaZE.Credito
                                }, {
                                    label: "Cheque",
                                    value: models.TipoPagoEntregaZE.Cheque
                                }
                            ]}
                        />
                    </div>
                }
            </div>
        )
    }
}

const PagoEntregaCompRX = componentToRx(PagoEntregaCompNoRX);

export interface Props {
    value: models.EntregaZERealizadaDTO;
    onChange: (x: models.EntregaZERealizadaDTO) => void;
    idCliente: number;
}

class PagoEntregaComp extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    idCliente = (props: Props) => props.idCliente;
    tipoPago = (props: Props) => props.value.TipoPago;


    total = createSelectorRx(this.value, (value) => obtenerTotalAPagar(value));
    cliente = createSelectorRx(this.idCliente, idCliente => observeResource(resources.Cliente.ConsultarDatosCredito, idCliente));
    limiteCredito = createSelectorRx(this.cliente, cliente => cliente && cliente.LimiteCredito);
    creditoBloqueado = createSelectorRx(this.cliente, cliente => cliente && cliente.CreditoBloqueado);
    saldo = createSelectorRx(this.cliente, cliente => cliente && cliente.SaldoCredito);
    saldoSuficiente = createSelectorRx(this.saldo, this.limiteCredito, (saldo, limiteCredito) => saldo <= (limiteCredito || 0));
    saldoCliente = createSelectorRx(this.saldo, this.limiteCredito, (saldo, limiteCredito) => ({ saldo: saldo, limite: (limiteCredito || 0) }) as saldoCliente);

    onTipoPagoChange = (tipo: models.TipoPagoEntregaZE) => {
        this.props.onChange({
            ...this.props.value,
            TipoPago: tipo
        });
    }

    render() {
        const total = this.total(this.props);
        const tipopago = this.tipoPago(this.props);
        const saldoSuficiente = this.saldoSuficiente(this.props);
        const saldoCliente = this.saldoCliente(this.props);
        const creditoBloqueado = this.creditoBloqueado(this.props);

        return (
                total.todas >0 &&
                <PagoEntregaCompRX
                total={total}
                tipopago={tipopago}
                saldoSuficiente={saldoSuficiente}
                saldoCliente={saldoCliente}
                creditoBloqueado={creditoBloqueado}
                onChange={this.onTipoPagoChange}
            /> 
        )
    }
}

export const PagoEntrega = componentToRx(PagoEntregaComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/pago.tsx